export const hoverEffect = {
    whileHover: {
        scale: 1.03,
        boxShadow: '0 8px 24px rgba(217, 38, 45, 0.2)',
        transition: { duration: 0.3 }
    },
    whileTap: { scale: 0.98 }
};